import { FC } from 'react';
import { ProvisioningProvider, ProvisioningProviderProps } from '@cld/session-service';
import { useCustomerIdContext } from '../../context';

export const CustomerProvisioningProvider: FC<React.PropsWithChildren<Omit<ProvisioningProviderProps, 'customer' | 'updateCustomer'>>> = (props) => {
  const { currentCustomer, updateCurrentCustomer } = useCustomerIdContext();

  return <ProvisioningProvider customer={currentCustomer} updateCustomer={updateCurrentCustomer} {...props} />;
};
